import { TrendingUp, TrendingDown } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface MobileSummaryCardsProps {
  income: number;
  expenses: number;
  onIncomeClick?: () => void;
  onExpenseClick?: () => void;
  isLoading?: boolean;
}

const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount);
};

export const MobileSummaryCards = memo(function MobileSummaryCards({
  income,
  expenses,
  onIncomeClick,
  onExpenseClick,
  isLoading = false
}: MobileSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="px-4 mb-6">
        <div className="grid grid-cols-2 gap-4">
          <Card className="border-border">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <Skeleton className="h-4 w-16" />
                <Skeleton className="h-5 w-5 rounded-full" />
              </div>
              <Skeleton className="h-6 w-24" />
            </CardContent>
          </Card>
          <Card className="border-border">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <Skeleton className="h-4 w-16" />
                <Skeleton className="h-5 w-5 rounded-full" />
              </div>
              <Skeleton className="h-6 w-24" />
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 mb-6">
      <div className="grid grid-cols-2 gap-4">
        {/* Card de Receitas */}
        <Card 
          className="bg-card border-border transition-all duration-300 hover:bg-accent/30 hover:shadow-medium cursor-pointer shadow-soft"
          onClick={onIncomeClick}
        >
          <CardContent className="p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-body-sm text-muted-foreground">Receitas</span>
              <div className="bg-success/10 rounded-full p-1">
                <TrendingUp className="h-3 w-3 text-success" />
              </div>
            </div>
            <div className="text-amount-sm font-bold tabular-nums text-success">
              {formatCurrency(income)}
            </div>
          </CardContent>
        </Card>

        {/* Card de Despesas */}
        <Card 
          className="bg-card border-border transition-all duration-300 hover:bg-accent/30 hover:shadow-medium cursor-pointer shadow-soft"
          onClick={onExpenseClick}
        >
          <CardContent className="p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-body-sm text-muted-foreground">Despesas</span>
              <div className="bg-destructive/10 rounded-full p-1">
                <TrendingDown className="h-3 w-3 text-destructive" />
              </div>
            </div>
            <div className="text-amount-sm font-bold tabular-nums text-destructive">
              {formatCurrency(expenses)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
});